export const getWLDriversByCountryApi = async (forecastApi, countryCode, signal) => {
    const res = await forecastApi.jsonInJsonOut(`/driver/country/${countryCode}`, {
        method: "GET",
        signal,
    });
    return res.payload;
};
//# sourceMappingURL=getWLDriversByCountryApi.js.map